import React, { useState } from 'react';
import './ProgressBubbles.styles.scss';
import { getClassName } from "../../core/helpers";
import ThirdHeading from "../ThirdHeading/ThirdHeading";

function ProgressBubbles({ data }) {
    const [activeItemIndex, setActiveItemIndex] = useState(-1);
    return (
        <>
            <div className="decision-sequence">
                <div className="decision-sequence__top">
                    <ThirdHeading>
                        for this event, consumers FIRST decide
                    </ThirdHeading>
                    {activeItemIndex >= 0 && (
                        <div className="decision-sequence__wrap">
                            <div>consumers most often start with <span>{data[activeItemIndex].name}</span> ({data[activeItemIndex].value}% of the time)
                            </div>
                            <div>of those times… the next most common decision is <span>{data[activeItemIndex].subItems[0].name}</span> ({data[activeItemIndex].subItems[0].value}% of
                                the time)
                            </div>
                            <div>and of those times… consumers next choose <span>{data[activeItemIndex].subItems[1].name}</span> ({data[activeItemIndex].subItems[1].value}% of the
                                time), and finally <span>{data[activeItemIndex].subItems[2].name}</span></div>
                        </div>
                    )}
                </div>
            </div>
            <div className="ProgressBubbles">
                {data.map((column, index) => {
                    const classList = new Set(['ProgressBubblesItem']);
                    const isActive = activeItemIndex === index;
                    if (isActive) classList.add('ProgressBubblesItem--active');
                    return (
                        <div
                            key={index}
                            className={getClassName(classList)}
                            onClick={() => setActiveItemIndex(index)}
                        >
                            <div className="ProgressBubblesItem__value">{column.value}%</div>
                            <div className="ProgressBubblesItem__name">{column.name}</div>
                            <div className="ProgressBubblesItem__sub-items">
                                {isActive && column.subItems.map((subItem, index) => (
                                    <div key={index} className="ProgressBubblesSubItem">
                                        <div className="ProgressBubblesSubItem__value">{subItem.value}%</div>
                                        <div className="ProgressBubblesSubItem__name">{subItem.name}</div>
                                    </div>
                                ))}
                                <div className="ProgressBubblesItem__line"/>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default ProgressBubbles;